import { getDashboardAssistantNavigationTarget } from '@charitystack/dashboard-assistant-contracts';

function target(name) {
  const value = getDashboardAssistantNavigationTarget(name);
  if (!value) throw new Error(`Unknown dashboard assistant navigation target: ${name}`);
  return value;
}

export const NAV_OPEN_DASHBOARD = target('open_dashboard');
export const NAV_OPEN_HOME = target('open_home');
export const NAV_OPEN_PAYMENTS = target('open_payments');
export const NAV_OPEN_CONTACTS = target('open_contacts');
export const NAV_OPEN_SUBSCRIPTIONS = target('open_subscriptions');
export const NAV_OPEN_FORMS = target('open_forms');
export const NAV_OPEN_ELEMENTS = target('open_elements');
export const NAV_OPEN_PAYOUTS = target('open_payouts');
export const NAV_OPEN_SETTINGS = target('open_settings');
export const NAV_OPEN_CREATE_CONTACT = target('open_create_contact');
export const NAV_OPEN_CREATE_PAYMENT = target('open_create_payment');
export const NAV_OPEN_CREATE_FORM = target('open_create_form');
export const NAV_OPEN_CREATE_EVENT_FORM = target('open_create_event_form');
export const NAV_OPEN_CREATE_ELEMENT = target('open_create_element');
